module.exports = {
  addthis: require('./addthis'),
  buffer: require('./buffer'),
  diaspora: require('./diaspora'),
  facebook: require('./facebook'),
  flattr: require('./flattr'),
  flipboard: require('./flipboard'),
  info: require('./info'),
  linkedin: require('./linkedin'),
  mail: require('./mail'),
  pinterest: require('./pinterest'),
  pocket: require('./pocket'),
  print: require('./print'),
  qzone: require('./qzone'),
  reddit: require('./reddit'),
  stumbleupon: require('./stumbleupon'),
  telegram: require('./telegram'),
  tencent: require('./tencent-weibo'),
  threema: require('./threema'),
  tumblr: require('./tumblr'),
  twitter: require('./twitter'),
  vk: require('./vk'),
  weibo: require('./weibo'),
  whatsapp: require('./whatsapp'),
  xing: require('./xing')
}
